<script>
import {
    Radar
} from 'vue-chartjs'
export default {
    extends: Radar,
    props: ['data', 'names', 'title', 'label'],
    data() {
        return {
            chartData: {
                labels: [],
                datasets: [{
                    label: '',
                    backgroundColor: "rgba(255,99,132,0.2)",
                    borderColor: "rgba(255,99,132,1)",
                    pointBackgroundColor: "rgba(255,99,132,1)",
                    pointBorderColor: "#fff",
                    pointHoverBackgroundColor: "#fff",
                    pointHoverBorderColor: "rgba(255,99,132,1)",
                    data: []
                }]
            }
        }
    },
    mounted() {     
        this.chartData.labels = this.names;
        if(this.label){
            this.chartData.datasets[0].label = this.label;
        }
        // console.log("Radar", this.title);        
        this.names.forEach(key => {
            // console.log("key", this.data[key]);
            if (this.data.hasOwnProperty(key)) {
                this.chartData.datasets[0].data.push(parseInt(this.data[key]));
            }
        });
        
        let options = {
            // cutoutPercentage: 10,
            // scales: {
            // 	yAxes: [{
            // 		stacked: true
            // 	}]
            // },
            responsive: true,
            title: {
                display: true,
                position: 'top',
                text: this.title
            }
            // maintainAspectRatio: false
        };
        this.renderChart(this.chartData, options);
    }
}
</script>

<style scoped>
.small {
    max-width: 400px;
    margin: 150px auto;
}
</style>



// WEBPACK FOOTER //
// resources/js/chart/RadarChart.vue